import React from "react";
import SeoContent2 from './../../HomePage/SeoContent/SeoContent2';

const DegreeGuide = () => {
  return (
    <div className="birthCertProcedureContainer">
      <h2>
        Step-by-Step Guide to Degree Certificate <span>Attestation</span> in
        Bangalore{" "}
      </h2>
      <ol>
        <li>
          1. <span>Initial Consultation:</span> Contact Goodway Attestation to
          schedule an initial consultation. Our experts will explain the
          attestation process and answer any questions you may have.
        </li>
        <li>
          2. <span>Document Submission:</span> Gather all the required
          documents, including the original degree certificate, photocopies,
          passport copy, and passport-sized photographs. Submit these documents
          to our office.
        </li>
        <li>
          3. <span>Verification</span>: We will verify the degree certificate
          from the issuing institution to ensure its authenticity.
        </li>
        <li>
          4. <span>Notary Attestation:</span> The first step in the attestation
          process involves getting the document attested by a notary.
        </li>
        <li>
          5. <span>Home Department Attestation:</span> Next, we will submit the
          document to the Home Department for attestation.
        </li>
        <li>
          6. <span>HRD Attestation:</span> After Home Department attestation,
          the document will be attested by the HRD department.
        </li>
        <li>
          7. <span>MEA Attestation:</span> The next step is attestation by the
          Ministry of External Affairs.
        </li>
        <li>
          8. <span>Embassy Attestation:</span> Finally, the document will be
          attested by the embassy of the destination country.
        </li>
        <li>
          9. <span>Completion:</span> Once all the attestations are completed,
          we will inform you, and you can collect your attested degree
          certificate from our office.
        </li>
      </ol>
      <p>
        Degree certificate attestation is a vital step for individuals looking
        to use their academic qualifications abroad for higher studies,
        employment, or migration. Goodway Attestation offers reliable and
        efficient degree certificate attestation services in Bangalore, ensuring
        that your documents are authenticated and ready for international
        acceptance. With our expertise and commitment to excellence, you can
        trust us to handle your degree certificate attestation needs
        professionally and promptly. Contact Goodway Attestation today to start
        your degree certificate attestation process and take the first step
        towards achieving your international goals.
      </p>
      <SeoContent2 />
    </div>
  );
};

export default DegreeGuide;
